<template>
  <div class="ItemWave-wrap">
    <div class="header">
      <!--Waves Container-->
      <div>
        <svg
          class="waves"
          :style="waveStyle"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 24 150 28"
          preserveAspectRatio="none"
          shape-rendering="auto"
        >
          <defs>
            <path
              id="gentle-wave"
              d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
            />
          </defs>
          <g class="parallax">
            <use xlink:href="#gentle-wave" x="48" y="0" :fill="fillColors[0]" />
            <use xlink:href="#gentle-wave" x="48" y="3" :fill="fillColors[1]" />
            <use xlink:href="#gentle-wave" x="48" y="5" :fill="fillColors[2]" />
            <use xlink:href="#gentle-wave" x="48" y="7" :fill="fillColors[3]" />
          </g>
        </svg>
      </div>
      <!--Waves end-->
    </div>
    <!--Header ends-->
  </div>
</template>

<script>
export default {
  name: 'ItemWave',
  props: {
    color: {
      type: String,
      default: '255,255,255'
    },
    height: {
      type: String,
      default: '15vh'
    },
    minHeight: {
      type: String,
      default: '20px'
    },
    maxHeight: {
      type: String,
      default: '40px'
    }
  },
  computed: {
    waveStyle () {
      const { height, minHeight, maxHeight } = this
      return {
        height, minHeight, maxHeight
      }
    },
    colorRGB () {
      const c = this.color
      if (c[0] === '#') {
        if (c.length === 7) {
          return [
            parseInt(c.substr(1, 2), 16),
            parseInt(c.substr(3, 2), 16),
            parseInt(c.substr(5, 2), 16)
          ].join(',')
        } else if (c.length === 4) {
          return [
            parseInt(c[1], 16) * 16,
            parseInt(c[2], 16) * 16,
            parseInt(c[3], 16) * 16
          ].join(',')
        } else {
          // 預設白色
          console.warn('ItemWave invalid prop "color"', this.color)
          return 'rgb(255,255,255)'
        }
      } else {
        return this.color.replace('rgb(', '').replace(')', '')
      }
    },
    fillColors () {
      const colors = new Array(4)
      const alpha = [0.3, 0.5, 0.7, 0.9]
      for (let i = 0; i < 4; i++) {
        colors[i] = `rgba(${this.colorRGB},${alpha[i]}`
      }
      console.log('colors', colors)
      return colors
    }
  },
  data () {
    return {}
  },
  created () {},
  methods: {}
}
</script>
<style scoped lang="scss">
.ItemWave-wrap {
  width: 100%;
  // position: absolute;
}
// 海浪波浪 css start
.header {
  position: relative;
  // text-align: center;
  // background: linear-gradient(60deg, rgba(84, 58, 183, 1) 0%, rgba(0, 172, 193, 1) 100%);
  // color: white;
}
.waves {
  position: relative;
  width: 100%;
  margin-bottom: -7px; /*Fix for safari gap*/
}

/* Animation */
.parallax > use {
  animation: move-forever 25s cubic-bezier(0.55, 0.5, 0.45, 0.5) infinite;
}
.parallax > use:nth-child(1) {
  animation-delay: -2s;
  animation-duration: 7s;
}
.parallax > use:nth-child(2) {
  animation-delay: -3s;
  animation-duration: 10s;
}
.parallax > use:nth-child(3) {
  animation-delay: -4s;
  animation-duration: 13s;
}
.parallax > use:nth-child(4) {
  animation-delay: -5s;
  animation-duration: 20s;
}
@keyframes move-forever {
  0% {
    transform: translate3d(-90px, 0, 0);
  }
  100% {
    transform: translate3d(85px, 0, 0);
  }
}
/*Shrinking for mobile*/
// @media (max-width: 768px) {
//   .waves {
//     height: 40px;
//     min-height: 20px;
//   }
//   .content {
//     height: 30vh;
//   }
//   h1 {
//     font-size: 24px;
//   }
// }
// 海浪波浪 css end
</style>
<style lang="scss"></style>
